var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "step1" },
    [
      _c(
        "b-form",
        {
          ref: "productForm",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.formSubmitted($event)
            },
            change: function ($event) {
              return _vm.formChanged()
            },
          },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Product Name*",
                        "label-for": "mc-Product-name",
                      },
                    },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required", name: "Product Name" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("b-form-input", {
                                  attrs: {
                                    id: "mc-Product-name",
                                    placeholder: "Product Name",
                                    required: "",
                                  },
                                  model: {
                                    value: _vm.details.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.details, "name", $$v)
                                    },
                                    expression: "details.name",
                                  },
                                }),
                                errors.length
                                  ? _c(
                                      "small",
                                      { staticClass: "text-danger text-end" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Product Classification*",
                        "label-for": "mc-Product-name",
                      },
                    },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: "required",
                          name: "Product classification",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var errors = ref.errors
                              return [
                                _c("b-form-select", {
                                  attrs: { options: _vm.productTypes },
                                  model: {
                                    value: _vm.details.type,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.details, "type", $$v)
                                    },
                                    expression: "details.type",
                                  },
                                }),
                                errors.length
                                  ? _c(
                                      "small",
                                      { staticClass: "text-danger text-end" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "label-for": "mc-stock-threshold",
                        label: "Unit Of Measure",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "form-label-group" },
                        [
                          _c("b-form-select", {
                            attrs: {
                              options: _vm.itemUoms,
                              "value-field": "id",
                              "text-field": "name",
                            },
                            model: {
                              value: _vm.details.uom,
                              callback: function ($$v) {
                                _vm.$set(_vm.details, "uom", $$v)
                              },
                              expression: "details.uom",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "2" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Enable Ecommerce",
                        "label-for": "mc-Product-Ecomm",
                      },
                    },
                    [
                      _c("b-form-checkbox", {
                        attrs: {
                          checked: "false",
                          name: "check-button",
                          switch: "",
                          inline: "",
                        },
                        model: {
                          value: _vm.details.isEcomm,
                          callback: function ($$v) {
                            _vm.$set(_vm.details, "isEcomm", $$v)
                          },
                          expression: "details.isEcomm",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Product Code",
                        "label-for": "mc-Product-Code",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "mc-Product-Code",
                          placeholder: "Product Code",
                        },
                        model: {
                          value: _vm.details.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.details, "code", $$v)
                          },
                          expression: "details.code",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Barcode", "label-for": "mc-Barcode" } },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "mc-Barcode",
                          type: "text",
                          placeholder: "Barcode",
                        },
                        model: {
                          value: _vm.details.barcode,
                          callback: function ($$v) {
                            _vm.$set(_vm.details, "barcode", $$v)
                          },
                          expression: "details.barcode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "label-for": "mc-stock-threshold",
                        label: "Low Stock Threshold",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "form-label-group" },
                        [
                          _c("validation-provider", {
                            attrs: {
                              name: "Low Stock Threshold",
                              rules: "min_value:0",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var errors = ref.errors
                                  return [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: "mc-stock",
                                        type: "text",
                                        placeholder: "Low Stock Threshold",
                                      },
                                      model: {
                                        value: _vm.details.lowStock,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.details, "lowStock", $$v)
                                        },
                                        expression: "details.lowStock",
                                      },
                                    }),
                                    _c(
                                      "small",
                                      { staticClass: "text-danger" },
                                      [_vm._v(_vm._s(errors[0]))]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "4" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: { label: "Category", "label-for": "mc-Category" },
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          options: _vm.parentCategoryList,
                          "value-field": "id",
                          "text-field": "name",
                        },
                        on: { change: _vm.setSubCategory },
                        model: {
                          value: _vm.details.categoryId,
                          callback: function ($$v) {
                            _vm.$set(_vm.details, "categoryId", $$v)
                          },
                          expression: "details.categoryId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "4" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        disabled: _vm.details.categoryId != null,
                        label: "Sub Category",
                        "label-for": "mc-subCategory",
                      },
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          options: _vm.subCategoryList,
                          "value-field": "id",
                          "text-field": "name",
                        },
                        model: {
                          value: _vm.details.productCategorySubId,
                          callback: function ($$v) {
                            _vm.$set(_vm.details, "productCategorySubId", $$v)
                          },
                          expression: "details.productCategorySubId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "4" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Preferred Supplier",
                        "label-for": "mc-Supplier",
                      },
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          options: _vm.suppliers,
                          "value-field": "id",
                          "text-field": "name",
                        },
                        model: {
                          value: _vm.details.supplierId,
                          callback: function ($$v) {
                            _vm.$set(_vm.details, "supplierId", $$v)
                          },
                          expression: "details.supplierId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-col",
                { staticClass: "mb-2", attrs: { cols: "12" } },
                [
                  _c("label", { attrs: { for: "textarea-default" } }, [
                    _vm._v("Product Description"),
                  ]),
                  _c("b-form-textarea", {
                    attrs: {
                      id: "textarea-default",
                      placeholder: "Product Description",
                      rows: "5",
                    },
                    model: {
                      value: _vm.details.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.details, "description", $$v)
                      },
                      expression: "details.description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c("label", { attrs: { for: "textarea-default" } }, [
                    _vm._v("Product Image"),
                  ]),
                  _c("b-form-file", {
                    ref: "file-input",
                    attrs: {
                      placeholder:
                        "Choose a product picture or drop it here...",
                      "drop-placeholder": "Drop picture here...",
                      accept: ".jpg, .jpeg, .png",
                    },
                    on: { change: _vm.handleFileChange },
                    model: {
                      value: _vm.details.file,
                      callback: function ($$v) {
                        _vm.$set(_vm.details, "file", $$v)
                      },
                      expression: "details.file",
                    },
                  }),
                  _vm.errorMessage.length > 0
                    ? _c("div", { staticClass: "error-message text-danger" }, [
                        _vm._v(_vm._s(_vm.errorMessage)),
                      ])
                    : _vm._e(),
                  _c("b-card-text", { staticClass: "my-2" }, [
                    _vm._v(" Selected Image: "),
                    _vm.imageSrc
                      ? _c("div", [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                position: "relative",
                                display: "inline-block",
                                "max-width": "10%",
                                height: "auto",
                              },
                            },
                            [
                              _c("img", {
                                staticClass:
                                  "img-thumbnail bg-transparent border-0",
                                attrs: {
                                  src: _vm.imageSrc,
                                  alt: "Selected Image",
                                },
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "position-absolute close-btn btn-overlay",
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "p-0",
                                      attrs: { variant: "link" },
                                      on: { click: _vm.clearImage },
                                    },
                                    [
                                      _c("feather-icon", {
                                        attrs: {
                                          icon: "XIcon",
                                          size: "24",
                                          color: "red",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    !_vm.imageSrc
                      ? _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.details.file ? _vm.details.file.name : ""
                            )
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("CustomFieldsDetails", {
            attrs: {
              AdditionalFields: _vm.details.additionalFields,
              ModuleReference: "Product",
            },
            on: { onchange: _vm.additionalFieldChanges },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }